.pickup-relay-tooltip-target {
  height: 24px;
  width: 24px;
}
